import { IcertisLookupOptionsResponseSchema } from "@common/schemas/icertis"

export function icertisLookupOptionsPath(optionsUrl: string): string {
  return `/api/integrations/icertis/lookup-options?optionsUrl=${encodeURIComponent(optionsUrl)}`
}

export function icertisLookupOptionLabels(response: unknown): string[] {
  const lookupOptions = IcertisLookupOptionsResponseSchema.parse(response)
  const displayColumn = lookupOptions.displayColumn ?? "SysId"
  return lookupOptions.rows
    .map((row) => row[displayColumn])
    .filter((value): value is string => typeof value === "string" && value.length > 0)
}
